import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useRecoilState } from "recoil"
import { sizeState, userObjState, pagesObjState } from "../recoil-atom"

import {
  Flex,
  FlexColumn,
  Input,
  Submit,
  DivRound,
} from "../styled-components-openmark"
import { Search as SearchIcon } from "@styled-icons/evaicons-solid"

const Search = ({ where }) => {
  const [size, setSize] = useRecoilState(sizeState)
  const [userObj, setUserObj] = useRecoilState(userObjState)

  const [word, setWord] = useState("")
  const onChange = (event) => {
    const {
      target: { value },
    } = event
    setWord(value)
  }

  const searchNaver = () =>
    window.open(`https://search.naver.com/search.naver?query=${word}`)
  const searchGoogle = () =>
    window.open(`https://www.google.com/search?q=${word}`)
  const onSubmit = (event) => {
    event.preventDefault()
    if (userObj.search === "naver") {
      searchNaver()
    } else if (userObj.search === "google") {
      searchGoogle()
    }
  }

  return (
    <>
      <DivRound
        bgColor={userObj.colors.b0}
        boxShadow={`1px 1px 6px -1px ${userObj.colors.b2}`}
        width={size.appWidth - 10}
      >
        <form onSubmit={onSubmit}>
          <SearchIcon size="30" color="#aaa" />
          <input
            type="text"
            placeholder={`on ${userObj.search}`}
            value={word}
            onChange={onChange}
          />
          {userObj.search === "naver" && (
            <>
              <Submit type="submit" value="N" width={50} bgColor={"#04CE5C"} />
              <div
                className="second-search"
                onClick={searchGoogle}
                style={{ backgroundColor: "#202124" }}
              >
                G
              </div>
            </>
          )}
          {userObj.search === "google" && (
            <>
              <Submit type="submit" value="G" width={50} bgColor={"#202124"} />
              <div
                className="second-search"
                onClick={searchNaver}
                style={{ backgroundColor: "#04CE5C" }}
              >
                N
              </div>
            </>
          )}
        </form>
      </DivRound>

      <style jsx>{`
        form {
          padding: 0 20px;
          display: grid;
          grid-template-columns: 30px 1fr 50px 30px;
        }
        input {
          margin: 0 3px;
          // border: solid 1px #444;
          border: none;
          border-radius: 5px;
          padding: 5px;
          outline: none;
          background-color: ${userObj.colors.b0};
          color: ${userObj.colors.f2};
          font-size: 1rem;
          width: ${size.appWidth - 160}px;
        }
        input::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: ${userObj.colors.b2};
          opacity: 1; /* Firefox */
        }
        input::-ms-input-placeholder {
          /* Microsoft Edge */
          color: ${userObj.colors.b2};
        }
        .second-search {
          margin: 5px;
          border-radius: 5px;
          width: 20px;
          opacity: 0.5;
          color: #eee;
          font-size: 12px;
          text-align: center;
          cursor: pointer;
        }
      `}</style>
    </>
  )
}

export default Search
